import { transformMarkdown } from "./markdownTransformer.js";
import markdownit from "markdown-it";

const regexMentions     = /^(?:<(@|@&|#)([0-9]+)>)/;
const regexEmojis       = /^<(a?):([^:]+):([0-9]+)>/;
const regexEveryone     = /^(?:^|\s)@(everyone)(?:$|\s)/;
const regexNumbers      = /^[\u0030-\u0039]\uFE0F\u20E3/;

function ruleDiscordEmphasis(state, silent) {
    const max               = state.posMax;
    const start             = state.pos;
    const startCharacter    = state.src.charCodeAt(start);
    let tag                 = "em";
    let count               = 1;

    // Ensure the first character is an emphasis character.
    if (startCharacter !== 0x2A /* * */ && startCharacter !== 0x5F /* _ */)
        return false;

    // Check if the emphasis is bold or underline, otherwise it's italic.
    if (state.src.charCodeAt(start + 1) === startCharacter) {
        count   = 2;
        tag     = (startCharacter === 0x2A)
            ? "strong"
            : "underline";
    }

    // Fix position.
    let pos = start + count;

    // Scan for the closing delimiter.
    while (pos < max) {
        const hasMatch = (count === 1)
            ? state.src.charCodeAt(pos) === startCharacter
            : state.src.charCodeAt(pos) === startCharacter && state.src.charCodeAt(pos + 1) === startCharacter;

        if (hasMatch) {
            if (silent) {
                // 👇 Avance le curseur pour simuler la consommation
                state.pos = pos + count;
                return true;
            }

            const markup = (count === 1)
                ? String.fromCharCode(startCharacter)
                : String.fromCharCode(startCharacter, startCharacter);

            const tokenOpen = state.push(`${tag}_open`, tag, 1);

            tokenOpen.markup    = markup;
            state.pos           = start + count;
            state.posMax        = pos;
            state.md.inline.tokenize(state);

            const tokenClose = state.push(`${tag}_close`, tag, -1);

            tokenClose.markup   = markup;
            state.pos           = pos + count;
            state.posMax        = max;

            return true;
        }

        pos++;
    }

    return false;
}

function ruleMentionAndEmoji(state, silent) {
    const content = state.src.slice(state.pos);

    {
        const match = regexEveryone.exec(content);

        if (match) {
            if (!silent) {
                const token = state.push("mention", "mention", 0);

                token.content   = match[0];
                token.attrs     = { type: match[1] };
            }

            state.pos += match[0].length;

            return true;
        }
    }

    {
        const match = regexMentions.exec(content);

        if (match) {
            if (!silent) {
                const token = state.push("mention", "mention", 0);

                token.content = match[0];

                token.attrs = {
                    id      : (match[2]),
                    type    : (match[1] === "@")
                        ? "user"
                        : (match[1] === "#")
                            ? "channel"
                            : "role",
                };
            }

            state.pos += match[0].length;

            return true;
        }
    }

    {
        const match = regexEmojis.exec(content);

        if (match) {
            if (!silent) {
                const token = state.push("emoji", "emoji", 0);

                token.content = match[0];

                token.attrs = {
                    animated    : match[1] === "a",
                    name        : match[2],
                    id          : match[3],
                };
            }

            state.pos += match[0].length;

            return true;
        }
    }

    return false;
}

function ruleUnicodeEmoji(state, silent) {
    const content   = state.src.slice(state.pos);
    const match     = regexNumbers.exec(content);

    if (match) {
        if (!silent) {
            const token = state.push("unicode_emoji", "unicode_emoji", 0);

            token.content = match[0];
        }

        state.pos += match[0].length;

        return true;
    }

    return false;
}

export function createDiscordMarkdownParser() {
    const markdown = new markdownit({ linkify: true });

    // Remove the existing emphasis rule that handles bold and italic
    markdown.inline.ruler.disable([ "emphasis" ]);

    // Add custom rules for Discord mentions and emojis.
    markdown.inline.ruler.push("mention", ruleMentionAndEmoji);
    markdown.inline.ruler.push("unicode_emoji", ruleUnicodeEmoji);

    // Add a custom bold rule.
    markdown.inline.ruler.push("emphasis", ruleDiscordEmphasis);

    return markdown;
}

export function parseDiscordMarkdown(markdownParser, content) {
    return transformMarkdown(markdownParser.parse(content, {}));
}
